module.exports = __webpack_public_path__ + "static/media/pingzhi.4e950b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/pingzhi.png
// module id = 390
// module chunks = 0